import request from "./request";
import requestOrder from "./requestOrder";
import requestPY from "./requestPY";
import requestFireBlock from "./requestFireBlock";
// auth
export const login = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/user/auth/login", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e?.response?.data);
      });
  });
};
export const getSession = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/profile/login-session")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e.response.data);
      });
  });
};

export const sessionLogout = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/user/auth/logout", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// auth
export const loginProfile = (data, token) => {
  request.defaults.headers.common.Authorization = token ? `${token}` : "";

  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/profile/token", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
};
export const resetPassword = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("/user/auth/email/resend", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e);
      });
  });
};
export const resetVerifyEmail = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/auth/forgot/password", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e);
      });
  });
};
export const getProfile = (token) => {
  request.defaults.headers.common.Authorization = token ? `${token}` : "";

  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/profile")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
};

export const register = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/user/auth/register", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
};

export const resendOtp = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("auth/resend/email", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const verifyOtp = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("auth/verifyEmail", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const verifyMobile = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("/user/auth/mobile/verify", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const resendMobile = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("/user/auth/mobile/resend", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addMobile = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/user/auth/add-number", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const resendEmail = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("/user/auth/email/resend", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const verifyEmail = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("/user/auth/email/verify", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const verify2FA = (data, token) => {
  request.defaults.headers.common.Authorization = token ? `${token}` : "";
  return new Promise(async (resolve, reject) => {
    await request
      .patch("/user/auth/verify", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const forgotPassword = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/auth/forgot/password", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const googleLogin = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/auth/google/login")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const changePassword = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/auth/password", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getUserProfile = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/profile")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addBankDetail = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/user/profile/bank-details", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getEmailOtp = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch("/user/auth/email/resend", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getUserProfileUpdate = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/profile", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getUserProfileUpdateToken = (data, token) => {
  request.defaults.headers.common.Authorization = token ? `${token}` : "";
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/profile", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const updateMobile = (data, token) => {
  request.defaults.headers.common.Authorization = token ? `${token}` : "";
  return new Promise(async (resolve, reject) => {
    await request
      .post("/user/auth/add-number", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addIdProof = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/profile/kyc/id-proof", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const approveKYC = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/profile/kyc/approve")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addKycInfo = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/kyc/info", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addKycNation = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/kyc/nationality", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addKycAddress = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/address", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addWhyUsing = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/why-using", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addAmount = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/amount", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const uploadDcoument = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/kyc/document", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const uploadFaceDoc = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/kyc/face/document", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const uploadEdd = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("user/profile/edd", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Firebase Token
export const userFireBaseToken = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("/user/notification", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Firebase remove Token
export const userFireBaseRemoveToken = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete("/user/notification")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getNotification = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/notification", { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const putNotification = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`/user/notification/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Buy Coins
export const getAllCoins = (page, ispagination, sizePerPage) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(
        `user/coin?page=${page}&sizePerPage=${sizePerPage}&pagination=${ispagination}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getCoinById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/coin/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getCoin = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/coin`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getCoinNetwrok = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/coin/network`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getAllP2PSupportedCoins = (
  page,
  ispagination,
  sizePerPage,
  isSell
) => {
  return new Promise(async (resolve, reject) => {
    const url = isSell
      ? `admin/P2PSupportCoin/sell?page=${page}&sizePerPage=${sizePerPage}&pagination=${ispagination}`
      : `admin/P2PSupportCoin?page=${page}&sizePerPage=${sizePerPage}&pagination=${ispagination}`;
    await request
      .get(url)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const buyCoin = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/coinbuysell`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// currency

export const getAllCurrency = (page, ispagination, sizePerPage) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(
        `admin/currency?page=${page}&sizePerPage=${sizePerPage}&pagination=${ispagination}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Get Payment methods from admin
export const getAllPaymethods = (page, ispagination, sizePerPage) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(
        `admin/paymentMethod?page=${page}&sizePerPage=${sizePerPage}&pagination=${ispagination}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPaymethodById = (Id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/paymentMethod/${Id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// User adding payment
export const addPayMethodByUser = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/userPaymentMethod`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editPayMethodByUser = (data, Id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`user/userPaymentMethod/${Id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deletePayMethodByUser = (Id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`user/userPaymentMethod/${Id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getp2pTrxById = (ID) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/userP2POrderTrx/${ID}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const disputeOrder = (ID, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/userP2POrderTrx/dispute/${ID}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getAllPayMethodByUser = (page, ispagination, sizePerPage) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(
        `user/userPaymentMethod?page=${page}&sizePerPage=${sizePerPage}&pagination=${ispagination}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPayMethodAddedByUser = (Id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/userPaymentMethod/${Id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// p2p add
export const getOrders = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("user/coinbuysell", { params: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getOrdersById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("user/coinbuysell/" + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addP2pOrder = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/userP2POrders`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const editP2pOrder = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`user/userP2POrders/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getMinMax = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/userP2POrders/prices`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const userP2PAds = (page, size, type, coin) => {
  return new Promise(async (resolve, reject) => {
    let url = `user/userP2PAds?page=${page}&sizePerPage=${size}&pagination=false&type=${type}`;
    if (coin) {
      url = `user/userP2PAds?page=${page}&sizePerPage=${size}&pagination=false&type=${type}&coin=${coin}`;
    }
    await request
      .get(url)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteP2pOrder = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`user/userP2POrders/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getAllP2pOrders = (page, ispagination, sizePerPage, params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/userP2POrders`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getP2PById = (Id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/userP2POrders/${Id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const placeP2POrder = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/userP2POrderTrx`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const verifyP2POrder = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/userP2POrderTrx/confirmation/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const confirmP2POrder = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/userP2POrderTrx/receiverConfirmation/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const cancelP2POrder = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`user/userP2POrderTrx/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getAllplacedP2POrder = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/userP2POrderTrx`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getAllplacedP2POrderForUser = (params, userId) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/userP2POrderTrx/user/${userId}`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getWallet = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/wallet`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getWalletBalance = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/wallet/total-balance`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// TRADING_PAIR

export const getTradingPair = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/trading-pair`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getTradingPairById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/trading-pair/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// ORDER
export const placePairOrder = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/order`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const placePairOrderCoinDcx = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .post(`api/orders/placeOrder`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const cancelPairOrderCoinDcx = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .post(`api/orders/cancleOrder`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const rateOrder = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/p2pOrderRating`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const getTradeHistory = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/orderTransaction`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getGraph = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/orderTransaction/graph`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getTradingPairOrder = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/order`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getTradingPairOrderById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/order/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const cancleOrder = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`user/order/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPairOrderById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/order/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const walletTransfer = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/walletTransfer`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Chats for order
export const createChat = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/chat`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getChats = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/chat?pagination=false`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getChatById = (Id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/chat/${Id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const deleteChat = (Id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`user/chat/${Id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addMessage = (orderId, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/chat/message/${orderId}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getOrderBook = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/orderTransaction/price`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getOrderBookCoinDcx = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .get(`/api/trading-pairs/orderBook`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getAllTransaction = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/orderTransaction/all`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getConvertCoin = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/walletTransfer/transaction`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getCoinOrderData = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/orderTransaction/coin`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// WALLET
export const getCoinNetwork = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/admin/coinNetwork`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getWalletAddress = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/user-wallet/trx/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getWalletOrders = (id, params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/user-wallet/transaction/${id}`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const postWithdraw = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/user/user-wallet/trxWithdrawRequest`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const starPair = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/trading-pair/star/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const fearIndex = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/coin-market-cap/fear-greed`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const globalData = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/coin-market-cap/global-metrics`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const topGainer = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/orderTransaction/gain-lose`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const topGainerCoinDCX = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .get(`/api/trading-pairs/gain-lose`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const WithdrawINR = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/user/coinbuysell/withdrawal`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const WithdrawHistory = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/user/coinbuysell/withdrawal/history`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getSumsubToken = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/profile/sumsub/token")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
};
export const getCategory = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/pair-category`, {
        params: {
          pagination: false,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const addNominee = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`user/nominee`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const deleteNominee = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`user/nominee`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const generate2FA = (token) => {
  request.defaults.headers.common.Authorization = token ? `${token}` : "";

  return new Promise(async (resolve, reject) => {
    await request
      .patch(`/user/auth/2fa/generate`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const verify2FAApi = (data, token) => {
  request.defaults.headers.common.Authorization = token ? `${token}` : "";
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`/user/auth/2fa/verify`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getDocumentToken = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .put("/user/profile/kyc/digio")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
};
export const getDocumentUpdate = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/user/profile/kyc/digio")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
};
export const getGraphForWallet = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`user/wallet/graph`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// PY42
export const activatePY42 = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .post(`/api/user/create`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPYPairs = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/trading-pairs`, { params: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPYPairsById = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/trading-pairs/${data}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getOpenOrdersPI42 = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/orders/open`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getHistoryOrdersPI42 = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/orders/history`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const closePosition = (id) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .delete(`/api/position/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPositionPI42 = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/position/history`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getTradePI42 = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/trade`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getTransactionPI42 = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/transaction`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const cancelOrderPI42 = (id) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .delete(`/api/orders/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getTradeBookPI42 = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/trading-pairs/aggTrade`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getOrderBookPI42 = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/trading-pairs/depth`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getOrdersByIdPI42 = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .get(`/api/orders/${data}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const orderPY42 = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .post(`/api/orders/place`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const setLeverageLimit = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestPY
      .post(`/api/orders/set-leverage`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// FIREBLOCK
export const getAssets = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestFireBlock
      .get(`/user/assets`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// GULLAK
export const getBasket = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .get(`/api/gullak/plans`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getBasketById = (id) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .get(`/api/gullak/plans/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const createBasket = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .post(`/api/gullak/plans`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const investInBasket = (data) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .post(`/api/gullak/purchase`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getPrecision = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .get(`/api/coindcx/pairs-details`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getGullakWallet = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .get(`/api/gullak/myplans`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getGullakTr = (params) => {
  return new Promise(async (resolve, reject) => {
    await requestOrder
      .get(`/api/gullak/myplans/transaction`, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
